import { useState } from "react";

import { useTransactionSigning } from "../../hooks/useTransactionSigning";

export interface UseTransactionSigningConfirmModalParams {
  onClose: VoidFunction;
  onSubmit: (scaToken: string) => Promise<void>;
  transactionId: string | string[];
}

export function useTransactionSigningConfirmModal({
  transactionId,
  onSubmit,
  onClose,
}: UseTransactionSigningConfirmModalParams) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { signTransaction, isLoading: isSigningInProgress } =
    useTransactionSigning();

  async function handleConfirm() {
    setIsSubmitting(true);
    const token = await signTransaction(transactionId);

    if (!token) {
      setIsSubmitting(false);

      return;
    }

    onSubmit(token)
      .catch(() => {})
      .finally(() => {
        setIsSubmitting(false);
        onClose();
      });
  }

  const isLoading = isSigningInProgress || isSubmitting;

  return {
    handleConfirm,
    isLoading,
  };
}
